import styled from 'styled-components' 

export default styled.div`
    
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border: 2px solid white;
    user-select: none;
    
`;

